themeBase.requestIdleCallback(() => {
  themeSettings.disableStickyHeader = () => themeBase.isDesktop;
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded(['cart.js', 'product-form.js'], () => {
      if (!customElements.get('product-footbar')) {
        class ProductFootbar extends HTMLElement {
          connectedCallback() {
            this.product = this.closest('.shopify-section')?.querySelector('.product') || document.querySelector('[id="MainProduct-' + this.dataset.sectionId + '"] .product');
            this.productButtonAddToCart = this.product?.querySelector('[name="add"]');
            this.variants = this.querySelector('[name="id"]');

            this.onChangeBound ??= this.onChange.bind(this);
            this.checkOverlayBound ??= this.checkOverlay.bind(this);
            this.variants?.addEventListener('change', this.onChangeBound);
            window.addEventListener('MutationObserverLoaded', this.checkOverlayBound);
            window.addEventListener('throttle30fpsMove', this.checkOverlayBound);
          }

          disconnectedCallback() {
            this.variants?.removeEventListener('change', this.onChangeBound);
            window.removeEventListener('MutationObserverLoaded', this.checkOverlayBound);
            window.removeEventListener('throttle30fpsMove', this.checkOverlayBound);
          }

          onChange(event) {
            const options = event.target.querySelectorAll('option');
            const productVariantSwitcher = this.product?.querySelector('variant-radios, variant-selects');

            options.forEach(element => {
              if (element.selected) {
                if (!productVariantSwitcher || String(productVariantSwitcher.currentVariant?.id || '') === element.value) return;
                const variantData = productVariantSwitcher.getVariantData();
                const currentVariant = variantData.variants.filter((variant) => {
                  return variant.id == element.value;
                })[0];

                if (!currentVariant) return;
                productVariantSwitcher.changeOptions(currentVariant.options);
                productVariantSwitcher.onVariantChange({
                  isFootbar: true
                });
                return false;
              }
            });
          }

          checkOverlay() {
            if (!this.productButtonAddToCart || !this.isConnected) return;
            const productButtonAddToCartBound = themeBounds.get(this.productButtonAddToCart);
            const isVisible = productButtonAddToCartBound.bottom < 0;

            this.classList[isVisible ? 'add' : 'remove']('product-footbar__wrapper--visible');

            if (isVisible) {
              document.documentElement.style.setProperty('--product-footbar-height', `${themeBounds.get(this).height.toFixed(1) / 10}rem`);
            } else {
              document.documentElement.style.setProperty('--product-footbar-height', '');
            }
          }
        }

        customElements.define('product-footbar', ProductFootbar);
      }
    });
  });
});